<template>
  <el-card>
    <el-row type="flex" justify="space-between" ref="barparent">
      <div class="flex_wrap">
        <div class="flex_box_center">
          <span>营业日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.businessDate" :picker-options="pickerOptionsStart" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 68%"></el-date-picker>
        </div>
        <div class="flex_box_center">
          &nbsp;&nbsp;
          <span style="display: inline-block; width: 120px">单位名称&nbsp;&nbsp;</span>
          <el-input v-model="query.corpName" oninput="value=value.toUpperCase()" placeholder="输入单位名称模糊搜索" @change="handleQueryLike"></el-input>
        </div>
      </div>
      <div style="margin: 6px 10px; min-width: 200px; text-align: right">
        <el-button style="margin: 6px 10px" @click="hanleQuery" type="primary">查询</el-button>
        <el-button type="primary" @click="handlePrint('print')">打印</el-button>
        <el-button type="primary" @click="handlePrint('preview')">打印预览</el-button>
        <el-button type="primary" v-if="isExport" @click="handleExport">导出</el-button>
      </div>
    </el-row>
  </el-card>
</template>

<script>
import DateUtils from '@/utils/DateUtils';

export default {
  props: {
    isExport: {
      type: Boolean,
      default: true,
    },
    isSales: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      mealListData: [],
      query: {
        businessDate: DateUtils.formatDate(new Date(), 'yyyy-MM-dd '),
        corpName: '',
      },
      pickerOptionsStart: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.$bus.$on('clearCorpName', () => {
      this.query.corpName = '';
    });
  },
  beforeDestroy() {
    this.$bus.$off('clearCorpName');
  },
  methods: {
    handleQueryLike(e) {
      this.query.corpName = e;
    },
    hanleQuery() {
      //   console.log(this.query);
      this.$bus.$emit('todoQuery', this.query);
    },
    //打印
    handlePrint(type) {
      this.$bus.$emit('todoPrintCatering', type);
    },
    handleExport() {
      this.$bus.$emit('todoExportCatering');
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card {
  width: 100%;

  .flex_wrap {
    flex-wrap: nowrap;
    margin-top: 10px;
  }
}
</style>
